import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { ConsentId } from '@/shared/enums';
import getDeviceUID from '@/shared/utils/get-device-uid';

export default async ({ $deferredLoader, $oneTrust, $router }) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  $deferredLoader.oneTrust.promise
    .then(() => {
      if (!$oneTrust.areConsentsAccepted([ConsentId.SENTRY, ConsentId.STRICTLY_NECESSARY])) {
        return;
      }

      const allowedUrls = process.env.VUE_APP_SENTRY_ALLOWED_URLS || '';

      Sentry.init({
        Vue,
        dsn: 'https://f3dbbc19bda1450db47043779d06dc57@o147275.ingest.sentry.io/5414526',
        release: process.env.VUE_APP_RELEASE,
        environment: process.env.VUE_APP_ENVIRONMENT,
        integrations: [
          new BrowserTracing({ routingInstrumentation: Sentry.vueRouterInstrumentation($router) }),
        ],
        allowUrls: allowedUrls.split(','),
        beforeSend(event, hint) {
          if (hint?.originalException?.isAxiosError || hint?.originalException?._isRouter) {
            return null;
          }

          const allowedPath = window.location.origin + '/static/js';
          const filename = event?.exception?.values?.[0]?.stacktrace?.frames?.at(-1)?.filename;
          return filename?.startsWith(allowedPath) ? event : null;
        },
      });

      Sentry.setUser({ id: getDeviceUID() });
    });
};
